import type { Sesong } from './sesong';

export type KaffepratData = {
  evergreen: string[];
  sesong: Partial<Record<Sesong, string[]>>;
};

export const SESONG_NOKLER_SPESIFIKK_SJANSE = 0.3;

let evergreen: string[] = [];
let sesongLinjer: Partial<Record<Sesong, string[]>> = {};
let lastet = false;

export function lastKaffeprat(data: KaffepratData): void {
  evergreen = Array.isArray(data.evergreen) ? [...data.evergreen] : [];
  sesongLinjer = {};
  if (data.sesong && typeof data.sesong === 'object') {
    for (const [k, v] of Object.entries(data.sesong)) {
      if (Array.isArray(v) && v.length > 0) {
        sesongLinjer[k as Sesong] = [...v];
      }
    }
  }
  lastet = true;
}

export function erKaffepratLastet(): boolean {
  return lastet;
}

export function antallEvergreen(): number {
  return evergreen.length;
}

export function antallSesong(sesong: Sesong): number {
  return sesongLinjer[sesong]?.length ?? 0;
}

export function tilfeldigKaffeprat(
  _dag: number,
  sesong: Sesong,
  rng: () => number = Math.random,
): string | null {
  void _dag;
  if (!lastet) return null;

  const sesongPool = sesongLinjer[sesong] ?? [];
  const harSesong = sesongPool.length > 0;

  if (harSesong && rng() < SESONG_NOKLER_SPESIFIKK_SJANSE) {
    const idx = Math.floor(rng() * sesongPool.length);
    return sesongPool[Math.min(sesongPool.length - 1, idx)];
  }

  if (evergreen.length === 0) {
    if (harSesong) {
      const idx = Math.floor(rng() * sesongPool.length);
      return sesongPool[Math.min(sesongPool.length - 1, idx)];
    }
    return null;
  }

  const idx = Math.floor(rng() * evergreen.length);
  return evergreen[Math.min(evergreen.length - 1, idx)];
}

export function _resetKaffepratForTest(): void {
  evergreen = [];
  sesongLinjer = {};
  lastet = false;
}
